import React from 'react';
import { Adjustment } from '../../main/components/AdjustmentsEditor/interfaces';

const PresetAdjustmentList = ({ adjustments }: { adjustments: Adjustment[] }) => {
  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.header,
          position: 'sticky',
          top: 0,
        }}
      >
        <div style={{ flex: 1, textAlign: 'left' }}>Adjustment set</div>
        <div style={{ flex: 1 }}>Parameter</div>
        <div style={{ width: '5.6vh' }}>Floor plan</div>
        <div style={{ width: '5.6vh' }}>Value</div>
      </div>
      {adjustments
        .sort((a, b) => a.setname.toLowerCase().localeCompare(b.setname.toLowerCase()))
        .map((adjustment, index) => (
          <PresetAdjustmentCard
            setname={adjustment.setname}
            config={adjustment.config}
            name={adjustment.name}
            value={adjustment.value}
          />
        ))}
    </div>
  );
};

interface PresetAdjustmentCardProps {
  setname: string;
  config: string;
  name: string;
  value: string | number;
}

const PresetAdjustmentCard: React.FC<PresetAdjustmentCardProps> = ({ setname, config, name, value }) => {
  return (
    <div style={styles.card}>
      <div style={styles.cardDetails}>
        <span style={{ flex: 1, textAlign: 'left' }}>{setname}</span>
        <span style={{ flex: 1 }}>{name}</span>
        <span style={{ width: '5.6vh' }}>{config}</span>
        <span style={{ width: '5.6vh' }}>${value}</span>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    flex: 1,
    overflowY: 'scroll',
    width: '100%',
    boxShadow: '0vh 0.8vh 3.2vh -0.4vh rgba(16, 29, 59, 0.1)',
    backgroundColor: '#fff',
    borderRadius: '1.6vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8f8f9',
    color: 'rgba(16, 29, 59, 0.6)',
    height: '4.4vh',
    borderBottom: '0.1vh solid #e1e2e6',
    padding: '0vh 1.6vh',
    fontSize: '1.2vh',
    fontWeight: '700',
  },
  addButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'rgba(16, 29, 59, 0.6)',
    fontSize: '2vh',
    cursor: 'pointer',
  },
  card: {
    color: 'rgba(16, 29, 59, 1)',
    padding: '0.8vh 1.6vh',
    borderRadius: '0.4vh',
    borderBottom: '0.1vh solid #e1e2e6',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4vh',
    fontWeight: '400',
  },
  iconButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
  },
  cardDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '0.4vh',
    fontSize: '1.4vh',
    fontWeight: '400',
  },
};

export default PresetAdjustmentList;
